import { Link } from "react-router-dom";
import Languageoption from "../../language-dropdown";

const ThemeSettings = ({ isShort }) => {

    return (
        <div className="row">
            <div className={`col-12${isShort ? '' : ' col-md-6'}`}>
                <div className="setting-item">
                    <div className="icon">
                        <img src="assets/images/clock-tab.png" alt="" />
                    </div>
                    <div className="label"><Link to="#">Check status transaction</Link></div>
                </div>

                <div className="setting-item">
                    <div className="icon">
                        <img src="assets/images/message.png" alt="" />
                    </div>
                    <div className="label"><Link to="/faq">Support / FAQ</Link></div>
                </div>
            </div>


            {/* <!-- Right Column --> */}
            <div className={`col-12${isShort ? '' : ' col-md-6'}`}>
                <div className="setting-item justify-content-between">
                    <div className="d-flex align-items-center">
                        <div className="icon">
                            <img src="assets/images/buy-sell-tab.png" alt="" />
                        </div>
                        <div className="label"><Link to="#">Language</Link></div>
                    </div>
                    {/* <div>English &rsaquo;</div> */}
                    <Languageoption />
                </div>

                <div className="setting-item justify-content-between">
                    <div className="d-flex align-items-center">
                        <div className="icon">
                            <img src="assets/images/icon-a.png" alt="" />
                        </div>
                        <div className="label"><Link to="#">Theme</Link> </div>
                    </div>
                    <div className="theme-toggle btn-group" role="group">
                        <button type="button" className="btn btn-light-box"><img src="assets/images/light.png" /> Light</button>
                        <button type="button" className="btn btn-light"><img src="assets/images/dark.png" /> Dark</button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ThemeSettings;